import { Box } from "@chakra-ui/react"
import Snippet, { ISnippetProps } from "@components/Snippet"
import { bp } from "@utils/MediaQueries"

export interface ISnipperGridProps {
  data: ISnippetProps[]
}

const SnippetGrid: React.FC<ISnipperGridProps> = ({ data }) => {
  return (
    <Box w="100%" p={bp("0", null, "0 0 0 0p5col")}>
      {data.map((item: ISnippetProps, idx: number) => (
        <Box
          key={idx}
          padding={bp("2rem 1rem", null, "1rem 0 2rem 0")}
          borderBottom="1px solid #B1B5B8"
        >
          <Snippet {...item} />
        </Box>
      ))}
    </Box>
  )
}

export default SnippetGrid
